import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Grid } from '@mui/material';
import { Button } from 'vetrf-ui';
import styles from '../../FormNestedBlock.module.scss';

type NestedBlockProps = {
  title?: string;
  children: ReactNode;
  index?: number;
  arrayLength?: number;
  removeMethod?: (index: number) => void;
  duplicateMethod?: () => void;
  isOneRequired?: boolean;
  withRemoveButton?: boolean;
  childBlock?: boolean;
  noHeader?: boolean;
  subtitle?: string;
};

const RemoveButton = ({
  index,
  removeMethod,
  isOneRequired,
  arrayLength,
}: Partial<NestedBlockProps>) => {
  if (isOneRequired && arrayLength === 1) {
    return null;
  }
  return (
    <div className={styles.nestedBlockButton}>
      <Button
        icon="trash"
        iconColor="red"
        iconSize={110}
        onClick={() => {
          removeMethod!(index!);
        }}
        onlyIcon
        tooltip="Отменить добавление"
      />
    </div>
  );
};

export const NestedBlock = ({
  title,
  children,
  index,
  removeMethod,
  duplicateMethod,
  isOneRequired,
  arrayLength,
  withRemoveButton,
  childBlock = false,
  noHeader,
  subtitle,
}: NestedBlockProps) => (
  <div className={classNames(styles.nestedBlock, childBlock && styles.nestedChildBlock)}>
    {!noHeader && (
      <div className={styles.nestedBlockHeader}>
        <Grid container>
          {!!title && <h2 className={styles.nestedBlockHeaderTitle}>{title}</h2>}
          {duplicateMethod && (
            <div className={styles.nestedBlockButton}>
              <Button
                icon="copy"
                iconColor="orange"
                iconSize={110}
                onClick={() => {
                  duplicateMethod();
                }}
                onlyIcon
                tooltip="Дублировать"
              />
            </div>
          )}
          {withRemoveButton && (
            <RemoveButton
              index={index}
              removeMethod={removeMethod}
              isOneRequired={isOneRequired}
              arrayLength={arrayLength}
            />
          )}
        </Grid>
        {subtitle && <h3 className={styles.nestedBlockHeaderSubtitle}>{subtitle}</h3>}
      </div>
    )}
    <div className={styles.nestedBlockFields}>{children}</div>
  </div>
);
